import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class LoadingComponent implements OnInit {
	@Input() loading: boolean;

	constructor() {}

	ngOnInit(): void {}
}
